export default "__VITE_ASSET__Cpfp5XM3__"